import { useEffect, useState, forwardRef } from 'react';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import ProfileComponent from '../../components/dashboard/Profile';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';

import {
    Box,
    Divider,
    Grid,
    Typography,
    TextField,
    Button,
    Menu,
    MenuItem,
    Link as MuiLink,
    ListItemIcon,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Modal,
    InputBase,
    InputLabel,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Snackbar,
    Select,
    Stack,
    Pagination,
    Paper
} from "@mui/material";

import { blueGrey } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
  height: 70px;
  background-color: #c9d0d4;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Profile = () => {

    const [cartState, setCartState] = useState([]);
    const [profileData, setProfile] = useState({});
    const [authData, setAuth] = useState({});
    const [isCheckedOut, setCheckedOut] = useState(false);
    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    useEffect(() => {
      const getCart = async () => {
        try {
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });
          setCartState(cartData.data.result);
        } catch (err) {
          console.log(err);
        }
      };
      getCart();
    },[]);

    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} />
            <ProfileComponent profileData={profileData} updatedProfile={setProfile} authData={authData} />
            <FooterNav />
        </div>
    )
}

export default Profile
